export default __webpack_public_path__ + "static/media/google.b8c71e66.svg";